import { AppRouter } from '@/router/AppRouter';
import { PortalRouter } from '@/router/PortalRouter';

// Detect vendor portal by subdomain or path prefix
// - vendor.{tenant}.verigrc.com → PortalRouter
// - app.verigrc.com/portal/* → PortalRouter
// - app.verigrc.com/* → AppRouter
function isVendorPortal(): boolean {
  const hostname = window.location.hostname;
  const pathname = window.location.pathname;
  return hostname.startsWith('vendor.') || pathname.startsWith('/portal');
}

export default function Router() {
  return isVendorPortal() ? <PortalRouter /> : <AppRouter />;
}
